import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Classifiers", -1);
const _hoisted_2 = { key: 1 };
const _hoisted_3 = {
    key: 0,
    class: "p-2"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_5 = {
    key: 0,
    class: "p-2"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
import { useAsync } from "@/composables/useAsync";
import { onMounted } from 'vue';
import { apiCitizenClassifiers } from './api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenClassifiersPanel',
    props: {
        citizenId: {}
    },
    setup(__props) {
        const props = __props;
        const classifiers = useAsync();
        onMounted(() => {
            classifiers.fetch(apiCitizenClassifiers.getForCitizen(props.citizenId), "Failed to load classifiers");
        });
        const labels = {
            "livingPlace": "Where did you stay last night?",
            "livingDuration": "How long have you been staying there?",
            "homelessnessStart": "When did your homelessness start?",
            "timesOnTheStreet": "How many times have you stayed on the street, or in a shelter, in the past 3 years?",
            "monthsOnTheStreet": "For how many months in total have you been on the street in the past 3 years?",
            "healthInsurance": "Do you receive health insurance from any of the following?",
            "barriers": "Do any of the following barriers significantly affect your ability to live independently?",
            "domesticViolence": "Are you a survivor of domestic violence?",
            "veteran": "Are you a veteran, or in active military service?",
            "income": "What is your current monthly income, from any source?",
            "benefits": "Do you receive any non-cash benefits?",
            "expenses": "What are your current monthly expenses?",
            "consent": "Do you consent to share this information?",
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                (_unref(classifiers).status == 'loading')
                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                    : (_unref(classifiers).status == 'ready')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(labels, (label, questionId) => {
                                return _createElementVNode("div", { key: questionId }, [
                                    (_unref(classifiers).data[questionId] !== undefined)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                            _createElementVNode("strong", null, [
                                                _createElementVNode("u", null, _toDisplayString(label), 1)
                                            ]),
                                            _hoisted_4,
                                            _createElementVNode("ul", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classifiers).data[questionId].split('|'), (answer, id) => {
                                                    return (_openBlock(), _createElementBlock("li", { key: id }, _toDisplayString(answer == "" ? "None" : answer), 1));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]);
                            }), 64)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classifiers).data, (answer, questionId) => {
                                return (_openBlock(), _createElementBlock("div", { key: questionId }, [
                                    (!labels[questionId])
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                            _createElementVNode("strong", null, [
                                                _createElementVNode("u", null, _toDisplayString(questionId), 1)
                                            ]),
                                            _hoisted_6,
                                            _createTextVNode(" " + _toDisplayString(answer == "" ? "None" : answer), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
            ], 64));
        };
    }
});
